import { Box, Hidden, Paper, styled } from "@material-ui/core";
import Topbar from "../../Components/Customtopbar/Topbar";
import { IconButton, Tooltip, Grid } from "@mui/material";
import CustomDatePicker from "../../Components/CustomDatepicker/CustomDatePicker";
import CustomDocGroupInput from "../../Components/CustomDocgroupInput/customDocgroupinput";
import React, { useCallback, useEffect } from "react";
import CustomInput from "../../Components/CustomInput/CustomInput";
import Chackdocno from "../../CustomFunction/Docno/GetDocno";
import {
  DataGrid,
  GridActionsCellItem,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import ManageSearchRoundedIcon from "@mui/icons-material/ManageSearchRounded";
import CustomBackdrop from "../../Components/CustomBackdrop/Barckdrop";
import SelectStkJobOrderFG from "./Components/SelStkJobOrder/SelectStkJobOrderFG";
import FullScreenDialog from "../../Components/CustomDialogs/Fullscreendialog";
import ProductListData from "../../Components/ProductList/ProductListData";
import ListData from "../../Components/CustomUnit/Components/ListData";
import axios from "axios";
import { genpostURL, genpostURLTEST, genURL } from "../../_getjson";
import CustomDepartmentInput from "../../Components/CustomDepartment/CustomDepartmentInput";
import CustomSiteCodeInput from "../../Components/CustomSiteCode/CustomSiteCodeInput.js";
import CustomSnackbar from "../../Components/Snackbar/Snackbar";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import DateConvertByMoment from "../../CustomFunction/Date/DateconvertByMoment";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import WareHouse_Location from "../../Components/CustomWarehouse/Warehouse_location/Warehouse_location";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import PlaylistAddRoundedIcon from "@mui/icons-material/PlaylistAddRounded";
import CustomFGTypeInput from "../../Components/CustomFGTypeInput/customfgtypeinput.js";

const styleMenu = {
  color: "black",
  cursor: "pointer",
  fontFamily: "Customfont !important",
  // borderColor: "#bcbcbc",
  // backgroundColor: "#bcbcbc",

  zIndex: 100,
};

const listmenu = [["เลือกใบสั่งผลิต", "selStkJoborderFG"]];

export default function PSFG() {
  const [selectionModel, setSelectionModel] = React.useState([]);

  const [state, setState] = React.useState({
    docDate: Date.now(),
    docNo: "",
    docGroup: "",
    remark: "",
    userCode: localStorage.getItem("Username"),
    departmentCode: "",
    siteCode: "",
    sumCost: "",
    rowModesModel: {},
    openDialog: false,
    openDialogType: "",
    titleDialog: "เลือกรายการ",
    tableIDClick: -1,
    rowData: [],
    openBackdrop: false,
    verified: false,
    colorSnackbar: "success",
    openSnackbar: false,
    messageSnackbar: "",
    iconSnackbar: ErrorOutlineRoundedIcon,
    autoCloseSnackbar: 3600,
    // datagrid action
    onLoad: false,
    productCode: "",
    rowActivated: "",
    showUnitActions: true,
    showProductActions: true,
    // table state

    enableAddIcon: false,
    enableDelIcon: false,

    //GFType

    fgType: "",
  });
  const columns = [
    { field: "id", headerName: "id", width: 80, hide: true },
    {
      field: "rowNumber",
      headerName: "ลำดับ",
      width: 50,
      hide: false,
      flex: 0,
    },
    {
      field: "productcode",
      headerName: "รหัสสินค้า",
      width: 200,
      editable: true,
      flex: 0,
    },
    {
      field: "productActions",
      type: "actions",
      headerName: "",
      width: 10,
      hide: state.showProductActions,
      cellClassName: "actions",
      getActions: ({ id }) => {
        return [
          <GridActionsCellItem
            icon={<ManageSearchRoundedIcon />}
            label="ค้นหา"
            onClick={handleClick(id, "product")}
            color="inherit"
          />,
        ];
      },
    },
    {
      field: "productname",
      headerName: "ชื่อสินค้า",
      width: 150,
      editable: true,
      flex: 0,
    },
    {
      field: "warehouse",
      headerName: "คลัง",
      width: 100,
      editable: true,
      flex: 0,
      hide: false,
    },
    {
      field: "warehouseCode",
      headerName: "warehouseCode",
      width: 100,
      editable: true,
      flex: 0,
      hide: true,
    },
    {
      field: "location",
      headerName: "ที่เก็บ",
      width: 100,
      editable: true,
      flex: 0,
      hide: false,
    },
    {
      field: "locationCode",
      headerName: "locationCode",
      width: 100,
      editable: true,
      flex: 0,
      hide: true,
    },
    {
      field: "locationActions",
      type: "actions",
      headerName: "",
      width: 10,
      cellClassName: "actions",
      getActions: ({ id }) => {
        return [
          <GridActionsCellItem
            icon={<ManageSearchRoundedIcon />}
            label="ค้นหา"
            onClick={handleClick(id, "location")}
            color="inherit"
          />,
        ];
      },
    },

    {
      field: "unitcode",
      headerName: "รหัสหน่วยนับ",
      width: 100,
      editable: false,
      flex: 0,
      hide: true,
    },
    {
      field: "unitname",
      headerName: "หน่วย",
      width: 100,
      editable: false,
      flex: 0,
    },
    {
      field: "unitActions",
      type: "actions",
      headerName: "",
      width: 10,
      cellClassName: "actions",
      getActions: ({ id }) => {
        return [
          <GridActionsCellItem
            icon={<ManageSearchRoundedIcon />}
            label="ค้นหา"
            onClick={handleClick(id, "unit")}
            color="inherit"
          />,
        ];
      },
    },
    {
      field: "quantity",
      type: "number",
      headerName: "ปริมาณ",
      width: 100,
      editable: true,
      flex: 0,
    },
    {
      field: "unitcost",
      type: "number",
      headerName: "ราคาทุน@",
      width: 100,
      editable: true,
      flex: 0,
    },
    {
      field: "unitprice",
      type: "number",
      headerName: "จำนวนเงิน",
      width: 100,
      editable: true,
      flex: 0,
    },
    {
      field: "jobno",
      headerName: "jobno",
      width: 200,
      editable: false,
      flex: 0,
    },
    {
      field: "startdate",
      headerName: "เริ่มนับอายุLOT",
      width: 200,
      editable: false,
      flex: 0,
      hide: true,
    },
    {
      field: "startDateShow",
      headerName: "เริ่มนับอายุLOT",
      width: 200,
      editable: false,
      flex: 0,
    },
  ];
  useEffect(() => {
    if (state.docGroup !== "") {
      genDocNo();
    }
    return () => {};
  }, [state.docGroup]);
  useEffect(() => {
    if (state.verified === true) {
      saveData();
      setState((prevState) => ({
        ...prevState,
        verified: false,
      }));
    }
    return () => {};
  }, [state.verified]);

  useEffect(() => {
    console.log("productcode", state.productCode);
    return () => {};
  }, [state.productCode]);

  useEffect(() => {
    console.log("rowActivated", state.rowActivated);
    return () => {};
  }, [state.rowActivated]);

  useEffect(() => {
    if (state.tableIDClick > -1) {
      checkDataRow(state.tableIDClick);
    }
    return () => {};
  }, [state.tableIDClick]);

  const sumCostLoad = async (DocNo) => {
    let url = genURL(`csfg/GetSumCostData?user=&provenance=web&DocNo=` + DocNo);
    //let url = genURLTEST(`/GetSumCostData?user=&provenance=web&DocNo=` + DocNo)
    let sumCost;
    await axios.get(url).then((res) => {
      // console.log("res", res)
      if (res.status === 200) {
        if (res.data[0].Status === "success") {
          if (res.data[0].Data[0].SUMCOST === null) {
            sumCost = 0;
          } else {
            sumCost = res.data[0].Data[0].SUMCOST;
          }
        } else if (res.data[0].Status === "error") {
          setState((prevState) => ({
            ...prevState,
            messageSnackbar:
              "การเชื่อต่อผิดพลาด กรุณาลองใหม่อีกครั้ง" + res.data.Message,
            colorSnackbar: `warning`,
            iconSnackbar: ErrorOutlineRoundedIcon,
            openSnackbar: true,
          }));
        }
      } else {
        setState((prevState) => ({
          ...prevState,
          messageSnackbar:
            "การเชื่อต่อผิดพลาด กรุณาลองใหม่อีกครั้ง" + res.status,
          colorSnackbar: `warning`,
          iconSnackbar: ErrorOutlineRoundedIcon,
          openSnackbar: true,
        }));
      }
    });
    return sumCost;
  };

  const checkDataRow = (idData) => {
    if (state.rowData.length > 0) {
      //      console.log("ssssss", state.rowData.filter(row => { row.id === idData }).productcode)
      setState((prevState) => ({
        ...prevState,
        productCode: state.rowData.filter((data) => data.id === idData)[0]
          .productcode,
      }));
      // console.log("checkDataRow", idData, "rowData", state.rowData[idData - 1].productcode
      //state.rowData
    }
  };
  const handleClick = (id, type) => async () => {
    console.log("handleClick", id, "type", type);
    //state.rowData[i].productcode
    // setRows(rows.filter((row) => row.id !== id))
    setState((prevState) => ({
      ...prevState,
      openDialog: true,
      openDialogType: type,
      tableIDClick: id,
      // productCode: state.rowData.filter((row) => row.id === id).productcode
    }));
    // console.log("handleClick", state)
  };
  const genDocNo = async () => {
    // await setState((prevState) => ({
    //   ...prevState,
    //   openBackdrop: true
    // }))
    await Chackdocno(state.docGroup, "CSFG").then(async (result) => {
      console.log("genDocNo", result);
      setState((prevState) => ({
        ...prevState,
        docNo: result,
        // openBackdrop: false
      }));
    });
  };

  const onClickTopBar = (e) => {
    switch (e) {
      case "selStkJoborderFG":
        setState((prevState) => ({
          ...prevState,
          openDialog: true,
          openDialogType: e,
        }));
        break;
      case "save":
        // checkData()
        saveData();

        break;
      default:
        break;
    }
  };
  const saveData = async () => {
    // console.log("Savedatat");
    const parameter = new URLSearchParams();
    // ข้อมูลหลัก

    let mainData = {
      Createuser: state.userCode,
      Docdate: DateConvertByMoment(
        state.productionorderdate,
        "YYYY-MM-DD 00:00:00"
      ),
      Docno: state.docNo,
      Remark: state.remark,
      Department: state.departmentCode,
      Sitecode: state.siteCode,
      Sumcost: state.sumCost,
      Docgroup: state.docGroup,
      FGType: state.fgType,
    };
    parameter.append("mainData", JSON.stringify(mainData));
    //ข้อมูลในตาราง
    let tableData = [];
    for (
      let i = 0;
      i < state.rowData.length && state.rowData[i].productcode;
      i++
    ) {
      tableData.push({
        Productcode: state.rowData[i].productcode,
        Productname: state.rowData[i].productname,
        Warehouse: state.rowData[i].warehouseCode,
        Location: state.rowData[i].locationCode,
        Unitcode: state.rowData[i].unitcode,
        Quantity: state.rowData[i].quantity,
        Unitcost: state.rowData[i].unitcost,
        Unitprice: state.rowData[i].unitprice,
        Jobno: state.rowData[i].jobno,
        Startdate: state.rowData[i].startdate,
      });
    }
    parameter.append("tableData", JSON.stringify(tableData));
    // parameter.forEach(element => {
    //   console.log("element", element)
    // });
    // let url = genpostURL("csstkjoborder/InsertData?user=&provenance=web")
    //let url = genpostURLTEST("/SaveData?user=&provenance=web")
    let url = genpostURL("psgf/SaveData?user=&provenance=web");
    axios
      .post(url, parameter)
      .then((res) => {
        if (res.status === 200) {
          if (res.data[0].Status === "success") {
            setState((prevState) => ({
              ...prevState,
              messageSnackbar: "บันทึกข้อมูลสำเร็จ",
              colorSnackbar: "success",
              iconSnackbar: CheckRoundedIcon,
              openSnackbar: true,
            }));
          } else if (res.data[0].Status === "error") {
            setState((prevState) => ({
              ...prevState,
              messageSnackbar: res.data[0].Message,
              colorSnackbar: `warning`,
              iconSnackbar: ErrorOutlineRoundedIcon,
              openSnackbar: true,
            }));
          } else {
            setState((prevState) => ({
              ...prevState,
              messageSnackbar: "ไม่มีการทำงานใดๆในเวอร์วิส",
              colorSnackbar: `warning`,
              iconSnackbar: ErrorOutlineRoundedIcon,
              openSnackbar: true,
            }));
          }
        } else {
          setState((prevState) => ({
            ...prevState,
            messageSnackbar:
              "การเชื่อต่อผิดพลาด กรุณาลองใหม่อีกครั้ง" + res.status,
            colorSnackbar: `warning`,
            iconSnackbar: ErrorOutlineRoundedIcon,
            openSnackbar: true,
          }));
        }
      })
      .catch((e) => {
        setState((prevState) => ({
          ...prevState,
          messageSnackbar: "การเชื่อต่อผิดพลาด กรุณาติดต่อฝ่ายไอที err:" + e,
          colorSnackbar: `warning`,
          iconSnackbar: ErrorOutlineRoundedIcon,
          openSnackbar: true,
        }));
      });
  };
  const checkData = async () => {
    console.log("docGroup", state.docGroup);

    let nullDataIndex = state.rowData.findIndex(
      (data) => data.productcode === ""
    );

    if (state.docGroup === "" || typeof state.docGroup === "undefined") {
      setState((prevState) => ({
        ...prevState,
        openSnackbar: true,
        colorSnackbar: "warning",
        messageSnackbar: "กลุ่มข้อมูลต้องไม่เป็นค่าว่าง",
        verified: false,
      }));
    } else if (state.docNo === "" || typeof state.docNo === "undefined") {
      setState((prevState) => ({
        ...prevState,
        openSnackbar: true,
        colorSnackbar: "warning",
        messageSnackbar: "เลขที่เอกสารต้องไม่เป็นค่าว่าง",
        verified: false,
      }));
    } else if (state.rowData.length > 0 && nullDataIndex < 1) {
      setState((prevState) => ({
        ...prevState,
        openSnackbar: true,
        colorSnackbar: "warning",
        messageSnackbar: "รายการในตารางต้องไม่เป็นค่าว่าง",
        verified: false,
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        verified: true,
      }));
    }
  };
  const rsStkJobOrderFG = async (e) => {
    console.log("rsStkJobOrderFG", e);
    let newDataRow = [],
      updatedData; // ประกาศตัวแปรไว้เพื่อรับค่า
    //เช็ค productcode ใน rowData state
    let currentDataIndex = state.rowData.findIndex(
      (data) => data.productcode === ""
    );
    newDataRow.push(...state.rowData.slice(0, currentDataIndex)); // อ่านข้อมูลเดิมที่อยู่ใน state
    for (let i = 0; i < e.length; i++) {
      // วนค่าที่มาจากการเลือกรายหารจาก popup

      let sumCostData = await sumCostLoad(e[i]["JOBNO"]).then((data) => {
        return data;
        // Output: Data fetched successfully
      });
      updatedData = {
        ...state.rowData[currentDataIndex],
        productcode: e[i]["PRODUCTCODE"],
        productname: e[i]["PRODUCTNAME"],
        quantity: Number(e[i]["FGQTY"]),
        unitcode: e[i]["UNITCODE"],
        unitname: await getUnitName(e[i]["UNITCODE"]),
        jobno: e[i]["JOBNO"],
        startdate: e[i]["STARTDATE"],
        startDateShow: DateConvertByMoment(e[i]["STARTDATE"], "ll"),
        unitcost: sumCostData,
        unitprice: Number(e[i]["FGQTY"]) * Number(sumCostData),
      };
      newDataRow.push(updatedData); // เพิ่มข้อมูลชุดใหม่เข้าไปเพื่อต่อเข้ากับ state เดิม
      currentDataIndex++; // แถวถัดไป
    }
    newDataRow.push(...state.rowData.slice(currentDataIndex + 1)); // อ่านข้อมูลที่มีอยู่ใน state หลังจากเพิ่มตัวอัพเดท
    await setState((prevState) => ({
      ...prevState,
      openDialog: false, // ปิด popup
      rowData: newDataRow, // บันทึกค่าเข้า  rowData
    }));

    await console.log("newDataRow", newDataRow);
  };
  const resultProduct = async (e) => {
    //console.log("resultProduct", state.rowData)
    let newDataRow, updatedData;
    //เช็ค productcode ใน rowData state
    const currentDataIndex = state.rowData.findIndex(
      (data) => data.id === state.tableIDClick
    );
    updatedData = {
      ...state.rowData[currentDataIndex],
      productcode: e[0]["code"],
      productname: e[0]["name"],
      quantity: 1,
      unicode: e[0]["unitCode"],
      unitname: await getUnitName(e[0]["unitCode"]),
      unitcost: 0,
      unitprice: 0,
      //unitprice: Number(...state.rowData[currentDataIndex].quantity) * Number(...state.rowData[currentDataIndex].unitcost)
    };
    newDataRow = [
      ...state.rowData.slice(0, currentDataIndex), // อ่านข้อมูลเดิมที่อยู่ใน state
      updatedData,
      ...state.rowData.slice(currentDataIndex + 1), // อ่านข้อมูลที่มีอยู่ใน state หลังจากเพิ่มตัวอัพเดท
    ];
    await setState((prevState) => ({
      ...prevState,
      openDialog: false, // ปิด popup
      rowData: newDataRow, // บันทึกค่าเข้า  rowData
      tableIDClick: -1,
    }));
  };

  const getUnitName = async (value) => {
    let url = `CSUNIT/ByCode?code=` + value;
    let data = await axios.get(genURL(url)).then((e) => {
      return e.data[0].MYNAMETH;
    });
    return data;
  };

  const resultUnit = async (e) => {
    console.log("resultUnit", e);
    const currentDataIndex = state.rowData.findIndex(
      (data) => data.id === state.tableIDClick
    );
    // console.log("productCode", productCode, "currentDataIndex", currentDataIndex)
    // if (productcode=== -1) {
    let updatedData = {
      ...state.rowData[currentDataIndex],
      unitname: e[0]["name"],
      unitcode: e[0]["code"],
      quantity: 1,
    };
    let newDataRow = [
      ...state.rowData.slice(0, currentDataIndex),
      updatedData,
      ...state.rowData.slice(currentDataIndex + 1),
    ];
    // } else {
    //     updatedData = { ...state.rowData[productCode], qty: state.rowData[productCode]["qty"] + 1 };
    //     newDataRow = [...state.rowData.slice(0, productCode), updatedData, ...state.rowData.slice(productcode+ 1)]
    // }

    await setState((prevState) => ({
      ...prevState,
      openDialog: false,
      rowData: newDataRow,
      tableIDClick: -1,
    }));
  };

  const rsWarehouse = async (data) => {
    // balance
    // id
    // location
    // locationCode
    // outstandingReceipt
    // overdueDelivery
    // reserve
    // rowNumber
    // unit
    // unitCode
    // warehouse
    // warehouseCode
    const currentDataIndex = state.rowData.findIndex(
      (data) => data.id === state.tableIDClick
    );
    console.log("rsWarehouse re data ", data);
    // console.log("productCode", productCode, "currentDataIndex", currentDataIndex)
    let updatedData = {
      ...state.rowData[currentDataIndex],
      locationCode: data[0]["locationCode"],
      location: data[0]["location"],
      warehouseCode: data[0]["warehouseCode"],
      warehouse: data[0]["warehouse"],
    };
    let newDataRow = [
      ...state.rowData.slice(0, currentDataIndex),
      updatedData,
      ...state.rowData.slice(currentDataIndex + 1),
    ];
    await setState((prevState) => ({
      ...prevState,
      openDialog: false,
      rowData: newDataRow,
      tableIDClick: -1,
    }));
  };

  const handleCellEditCommit = async (params) => {
    const currentDataIndex = state.rowData.findIndex(
      (data) => data.id === params.id
    );
    //กรอกราคาต้นทน
    if (params.field == "unitcost") {
      let newDataRow, updatedData;
      // console.log("productCode", productCode, "currentDataIndex", currentDataIndex)
      updatedData = {
        ...state.rowData[currentDataIndex],
        unitcost: params.value,
        unitprice: params.value * state.rowData[currentDataIndex].quantity,
      };
      newDataRow = await [
        ...state.rowData.slice(0, currentDataIndex),
        updatedData,
        ...state.rowData.slice(currentDataIndex + 1),
      ];
      // console.log("handleCellEditCommit", currentDataIndex, "params.id", params.id, "params.value", params.value, state.rowData)
      await setState((prevState) => ({
        ...prevState,
        openDialog: false,
        rowData: newDataRow,
        tableIDClick: -1,
      }));
    }
    // กรอกจำนวฯเงิน
    if (params.field == "unitprice") {
      let newDataRow, updatedData;
      console.log(
        "currentDataIndex",
        currentDataIndex,
        state.rowData[currentDataIndex].quantity
      );
      let quantityValue = 0;
      if (state.rowData[currentDataIndex].quantity > 0) {
        quantityValue = state.rowData[currentDataIndex].quantity;
      } else {
        quantityValue = 1;
      }
      let unitcostValue = params.value / quantityValue;

      updatedData = {
        ...state.rowData[currentDataIndex],
        quantity: quantityValue,
        unitcost: unitcostValue,
        unitprice: params.value,
      };
      newDataRow = await [
        ...state.rowData.slice(0, currentDataIndex),
        updatedData,
        ...state.rowData.slice(currentDataIndex + 1),
      ];
      // console.log("handleCellEditCommit", currentDataIndex, "params.id", params.id, "params.value", params.value, state.rowData)

      await setState((prevState) => ({
        ...prevState,
        openDialog: false,
        rowData: newDataRow,
        tableIDClick: -1,
      }));
    }
    // ปริมาณ
    if (params.field == "quantity") {
      let newDataRow, updatedData;
      // console.log("productCode", productCode, "currentDataIndex", currentDataIndex)
      updatedData = {
        ...state.rowData[currentDataIndex],
        quantity: params.value,
        unitcost: state.rowData[currentDataIndex].unitcost,
        unitprice: state.rowData[currentDataIndex].unitcost * params.value,
      };
      newDataRow = await [
        ...state.rowData.slice(0, currentDataIndex),
        updatedData,
        ...state.rowData.slice(currentDataIndex + 1),
      ];
      // console.log("handleCellEditCommit", currentDataIndex, "params.id", params.id, "params.value", params.value, state.rowData)

      await setState((prevState) => ({
        ...prevState,
        openDialog: false,
        rowData: newDataRow,
        tableIDClick: -1,
      }));
    }
    if (params.field == "productcode") {
      if (params.value !== "") {
        checkProduct(currentDataIndex, params.value);
      }
    }
  }; // end handleCellEditCommit

  const checkProduct = async (currentDataIndex, val) => {
    let newDataRow, updatedData;

    let url = genURL("CSPRODUCT/Code?code=" + val);
    let res = await axios.get(url).then((e) => {
      return e;
    });

    console.log("checkProduct", res.data);

    if (res.data.length > 0) {
      //  console.log(res.data)
      //CODE:"00000-YSH73"
      // COSTTYPE: 0
      // CUSTORDER: "0.00"
      // DESCRIPTION: ""
      // GILOCATION: "8009001"
      // GIWAREHOUSE: "8009"
      // GRLOCATION: "8009001"
      // GRWAREHOUSE: "8009"
      // MAINGROUP: "02"
      // NAMEEN: ""
      // NAMESEARCH: ""
      // NAMETH: "ไฟท้ายชุด C100 สีแดง"
      // NETSTOCK: "3.00"
      // OLDCODE: ""
      // PICTURE1: ""
      // PICTURE2: ""
      // PICTURE3: ""
      // PICTURE4: ""
      // PRODUCTSET: 0
      // PURCHASEORDER: "0.00"
      // SALELASTPRICE: "360.00"
      // SALEORDER: "0.00"
      // SELFLAG: 0
      // STOCKQTY: "3.00"
      // STOCKQTYGI: "2.00ชุด"
      // STOCKQTYWH: "2.00"
      // STOCKTYPE: 0
      // STOCKUNIT: "07"
      // SUBGROUP1: "0201"
      // SUBGROUP2: "ZZ"
      // SUBGROUP3: "07"
      // SUBGROUP4: ""
      // SUBGROUP5: ""
      // TAXTYPE: 1
      // UNITNAME: "ชุด"

      updatedData = {
        ...state.rowData[currentDataIndex],
        productcode: res.data[0].CODE,
        productname: res.data[0].NAMETH,
        quantity: 1,
        unicode: res.data[0].STOCKUNIT,
        unitname: res.data[0].UNITNAME,
      };
      newDataRow = await [
        ...state.rowData.slice(0, currentDataIndex),
        updatedData,
        ...state.rowData.slice(currentDataIndex + 1),
      ];

      await setState((prevState) => ({
        ...prevState,
        openDialog: false,
        rowData: newDataRow,
        tableIDClick: -1,
      }));
    } else {
      if (val !== "") {
        await setState((prevState) => ({
          ...prevState,
          messageSnackbar: "ไม่พบข้อมูล",
          colorSnackbar: "warning",
          iconSnackbar: ErrorOutlineRoundedIcon,
          openSnackbar: true,
        }));
      }

      updatedData = {
        ...state.rowData[currentDataIndex],
        productcode: "",
        productname: "",
        quantity: "",
        unicode: "",
        unitname: "",
      };
      newDataRow = await [
        ...state.rowData.slice(0, currentDataIndex),
        updatedData,
        ...state.rowData.slice(currentDataIndex + 1),
      ];

      await setState((prevState) => ({
        ...prevState,
        openDialog: false,
        rowData: newDataRow,
        tableIDClick: -1,
      }));
    }
  };

  // ตารางใหม่
  React.useEffect(() => {
    // let newDataColumns = await datacolumns.push({ field: 'rowNumber', headerName: 'ลำดับ', width: 80, hide: false })
    // console.log("datacolumns", newDataColumns)
    setState({
      onload: true,
    });
    createRowFree();
    return () => {};
  }, []);

  const createRowFree = (rowcount) => {
    let newRows =
      typeof rowcount === "undefined" || rowcount === "" ? 100 : rowcount;
    if (state.rowData.length <= 0) {
      let field = [];
      columns.forEach((element) => {
        if (element.field != "id") {
          field.push(element.field);
        }
      });
      let data = [];
      //(prevRows) => [...prevRows, createRow(field, true)]
      for (let index = 0; index < newRows; index++) {
        data.push(createRow(field, true));
      }
      console.log("createRowFree", data);
      setState({
        rowData: data,
        onLoad: false,
      }); //มาแก้ตรงนี้
    }
  };

  let idCounter = 0;
  let rowNumber = 0;
  const createRow = (data, empty) => {
    // ถ้ามีข้อมูลใน rows state
    if (state.rowData.length > 0) {
      const ids = state.rowData.map((object) => {
        return object.id;
      });
      const max = Math.max(...ids);
      idCounter = max;

      const rowNumbers = state.rowData.map((object) => {
        return object.rowNumber;
      });
      const maxRowNumber = Math.max(...rowNumbers);
      rowNumber = maxRowNumber;
    }
    idCounter += 1;
    rowNumber += 1;
    let lastData;
    if (empty === true) {
      let newData = data.reduce((a, v) => ({ ...a, [v]: "" }), {});
      lastData = { ...newData, id: idCounter, rowNumber: rowNumber };
    }
    return lastData;
  };

  // resize Colum

  const handleCellEditStart = (prarm) => {
    console.log(prarm);
  };
  // menu table
  /////////test//////////////
  useEffect(() => {
    console.log("state.selectionModel.length", selectionModel.length);
    return () => {};
  }, []);
  const CustomToolbar = () => {
    return (
      <>
        <GridToolbarContainer id={`GridToolbarContainerPSFG`}>
          <Grid
            spacing={2}
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            sx={{ m: 0.1 }}
          >
            <Tooltip
              title="เพิ่มแถว"
              aria-label="addRows"
              style={{
                display: state.enableAddIcon === false ? "none" : "inherit",
              }}
              sx={{ styleMenu }}
            >
              <IconButton aria-label="addRows" onClick={(_) => handleAddRow()}>
                <PlaylistAddRoundedIcon />
              </IconButton>
            </Tooltip>
            <Tooltip
              title="ลบแถว"
              aria-label="delRows"
              style={{
                display:
                  selectionModel.length > 0
                    ? state.enableDelIcon === false
                      ? "none"
                      : "inherit"
                    : "none",
              }}
              sx={styleMenu}
            >
              <IconButton
                aria-label="delRows"
                onClick={(_) => handleDelDataClick()}
              >
                <DeleteOutlineRoundedIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        </GridToolbarContainer>
      </>
    );
  };

  const handleDelDataClick = async () => {
    const selectedIDs = new Set(selectionModel);
    // you can call an API to delete the selected IDs
    // and get the latest results after the deletion
    // then call setRows() to update the data locally here
    //  await setRows((r) => r.filter((x) => !selectedIDs.has(x.id)));
    let x = state.rowData.filter((x) => !selectedIDs.has(x.id));
    await setState((prevState) => ({
      ...prevState,
      rowData: x,
    }));
  };
  // เพิ่มแถวในตาราง
  const handleAddRow = async () => {
    if (
      state.rowData.length > 0 &&
      typeof state.rowData.length !== "undefined"
    ) {
      let newDataRow;
      let field = [];
      columns.forEach((element) => {
        if (element.field != "id") {
          field.push(element.field);
        }
      });
      newDataRow = await [
        ...state.rowData.slice(0, state.rowData.length),
        createRow(field, true),
      ];
      await setState((prevState) => ({ ...prevState, rowData: newDataRow }));
    } else {
      createRowFree(1);
    }
  };
  // end menu table
  return (
    <Box>
      <Topbar
        listmenu={listmenu}
        title="บันทึกใบรับสินค้า"
        onClick={(e) => onClickTopBar(e)}
      />
      <Grid container spacing={2} sx={{ m: 1 }}>
        <Grid xs={12} md={4} xl={4} lg={4}>
          <CustomDatePicker
            title={"วันที่สั่งผลิต"}
            DateValue={(e) =>
              setState((prevState) => ({
                ...prevState,
                docDate: e,
              }))
            }
          />
        </Grid>
        <Grid xs={12} md={4} xl={4} lg={4}>
          <CustomDocGroupInput
            label={"กลุ่มข้อมูล"}
            tablename={"CSFG"}
            resData={(e) =>
              setState((prevState) => ({
                ...prevState,
                docGroup: e,
              }))
            }
          />
        </Grid>
        <Grid xs={12} md={4} xl={4} lg={4}>
          <CustomInput
            label={"เลขที่เอกสาร"}
            readonly={true}
            defaultValue={state.docNo}
          />
        </Grid>
        <Grid xs={12} md={12} xl={12} lg={12}>
          <CustomInput
            label={"หมายเหตุ"}
            resData={(e) => {
              setState((prevState) => ({
                ...prevState,
                remark: e,
              }));
            }}
          />
        </Grid>
        <Grid sm={12} md={12} xl={12} xs={12}>
          {state.onLoad === false ? (
            <Box
              sx={{ height: "70vh" }}
              style={{ width: "100%" }}
              component="div"
            >
              <DataGrid
                rows={state.rowData}
                columns={columns}
                sx={{
                  fontFamily: "Customfont !important",
                  cursor: "pointer",
                }}
                rowHeight={30}
                hideFooter={true}
                // onCellEditStart={handleCellEditStart}
                components={{
                  Toolbar: CustomToolbar,
                  // LoadingOverlay: LinearProgress,
                }}
                checkboxSelection
                disableSelectionOnClick={true}
                selectionModel={selectionModel}
                onSelectionModelChange={(newSelectionModel) => {
                  setSelectionModel(newSelectionModel);
                }}
                // onRowEditStart={console.log("onRowEditStart")}
                onCellEditCommit={handleCellEditCommit}
                // onCellEditStop={handleOnCellEditStop}
                editMode={"cell"}
              />
            </Box>
          ) : (
            "กำลังโหลด..."
          )}
        </Grid>
        <Grid xs={12} md={4} xl={4} lg={4}>
          <CustomDepartmentInput
            label={"แผนก"}
            resData={(e) =>
              setState((prevState) => ({
                ...prevState,
                departmentCode: e,
              }))
            }
          />
        </Grid>
        <Grid xs={12} md={4} xl={4} lg={4}>
          <CustomSiteCodeInput
            label={"สาขา"}
            tablename={"CSFG"}
            resData={(e) =>
              setState((prevState) => ({
                ...prevState,
                siteCode: e,
              }))
            }
          />
        </Grid>

        <Grid xs={12} md={4} xl={4} lg={4}>
          <CustomFGTypeInput
            resData={(e) =>
              setState((prevState) => ({
                ...prevState,
                fgType: e,
              }))
            }
            label={"ประเภทการรับ"}
          />
        </Grid>
        <Grid xs={12} md={4} xl={4} lg={4}>
          <CustomInput
            label={"รวมต้นทุน"}
            readonly={false}
            defaultValue={state.sumCost}
            resData={(e) =>
              setState((prevState) => ({
                ...prevState,
                sumCost: e,
              }))
            }
          />
        </Grid>
      </Grid>
      <FullScreenDialog
        open={state.openDialog}
        title={state.titleDialog}
        CloseDialog={(e) =>
          setState((prevState) => ({
            ...prevState,
            openDialog: false,
            tableIDClick: -1,
          }))
        }
      >
        {state.openDialogType === "product" ? (
          <ProductListData resultData={(e) => resultProduct(e)} />
        ) : state.openDialogType === "unit" ? (
          <ListData resultData={(e) => resultUnit(e)} />
        ) : state.openDialogType === "location" && state.productCode !== "" ? (
          <WareHouse_Location
            resultData={(e) => rsWarehouse(e)}
            productCode={state.productCode}
            userCode={sessionStorage.getItem("Username")}
          />
        ) : state.openDialogType === "selStkJoborderFG" ? (
          <SelectStkJobOrderFG
            multiselect={true}
            resultData={(e) => rsStkJobOrderFG(e)}
          />
        ) : (
          "กำลังโหลด"
        )}
      </FullScreenDialog>
      <CustomBackdrop open={state.openBackdrop} key={"CustomBackdrop"} />
      <CustomSnackbar
        place="br"
        color={state.colorSnackbar}
        icon={state.iconSnackbar}
        autoClose={state.autoCloseSnackbar}
        message={state.messageSnackbar}
        open={state.openSnackbar}
        closeNotification={() => {
          setState((prevState) => ({ ...prevState, openSnackbar: false }));
        }}
        close
      />
    </Box>
  );
}
